import { Paper, Group, Text, ActionIcon, Stack } from 'components'
import { IconTrash } from '@tabler/icons-react'

interface LearningGoalsListProps {
  goals: string[]
  onRemove: (index: number) => void
}

export const LearningGoalsList = ({ goals, onRemove }: LearningGoalsListProps) => {
  if (goals.length === 0) return null

  const hasMultipleGoals = goals.length > 1

  return (
    <Stack spacing="xs">
      {goals.map((goal, index) => (
        <Paper
          key={index}
          p="sm"
          radius="md"
          withBorder
          sx={theme => ({
            backgroundColor: theme.colorScheme === 'dark'
              ? theme.colors.dark[6]
              : theme.colors.gray[0],
          })}
        >
          <Group position="apart" noWrap>
            <Text size="sm" style={{ flex: 1 }}>
              {hasMultipleGoals ? `${index + 1}. ${goal}` : goal}
            </Text>
            <ActionIcon
              size="sm"
              color="red"
              variant="light"
              onClick={() => onRemove(index)}
            >
              <IconTrash size={16} />
            </ActionIcon>
          </Group>
        </Paper>
      ))}
    </Stack>
  )
}
